<template>
  <b-row v-if="receipt_visits_conversion_context_loaded" class="m-0 pr-2 pb-2 pl-2">
    <b-container id="receipt_visits_conversion_graph" fluid class="white-box">
      <highcharts :options="chartOptions"></highcharts>
    </b-container>
  </b-row>
  <b-row v-else class="m-0 pr-2 pb-2 pl-2">
    <analytics-loader/>
  </b-row>
</template>

<script>
import Highcharts from 'highcharts'
import AnalyticsLoader from '@/components/AnalyticsLoader.vue';

export default {
  components: {
    AnalyticsLoader
  },
  computed: {
    receipt_visits_conversion_context_loaded() { return this.$store.getters.receipt_visits_conversion_context_loaded },
    is_multi_site_manager() { return this.$store.getters.is_multi_site_manager },
    semester_conversion() { return this.$store.getters.semester_conversion },
    semester_bucket() { return this.$store.getters.semester_bucket },
    semester_visits() { return this.$store.getters.semester_visits },
    bars_categories() { return this.$store.getters.bars_categories },
    chartOptions() {
      const semesterConversionArray = this.semester_conversion;
      const semesterBucketArray = this.semester_bucket;
      const semesterVisitsArray = this.semester_visits;
      const categories = this.bars_categories;
      const visitsVisible = !this.is_multi_site_manager;

      // Essa função serve para que a barra de porcentagem seja proporcional às demais barras
      function increaseBarByFactor(arrayData) {
        let i;
        let ret = [];
        let displayFactor =  Math.max.apply(null, semesterBucketArray) * 10;
        for (i = 0; i < arrayData.length; i++) {
          (arrayData[i]) ? ret.push(arrayData[i] * displayFactor) : ret.push(null);
        }
        return ret;
      }

      return {
        chart: {
          type: 'column'
        },
        xAxis: {
          categories: categories,
          crosshair: true
        },
        title: null,
        yAxis: {
          labels: {
            formatter: function () {
              return this.value / 1000 + 'k';
            }
          }
        },
        series: [{
          dataLabels: {
            formatter: function () {
              return 'R$ ' + Highcharts.numberFormat(this.y / 1000, 0, ',', '.') + 'k'
            },
            enabled: true
          },
          name: 'Receita',
          color: '#0BA7DA',
          data: semesterBucketArray,
          tooltip: {
            headerFormat: '<span style="color: {series.color}">{point.key}</span><br>',
            pointFormat: '<span style="color: {series.color}">{series.name}: R$ {point.y:,.2f}</span>',
            useHTML: true
          }
        }, {
          dataLabels: {
            formatter: function () {
              return Highcharts.numberFormat(this.y / 1000, 0, ',', '.') + 'k'
            },
            enabled: true
          },
          name: 'Visitas',
          color: '#FCBC2C',
          data: semesterVisitsArray,
          tooltip: {
            headerFormat: '<span style="color: {series.color}">{point.key}</span><br>',
            pointFormat: '<span style="color: {series.color}">{series.name}: {point.y:,.0f}</span>',
            useHTML: true
          },
          visible: visitsVisible
        }, {
          dataLabels: {
            formatter: function () {
              return Highcharts.numberFormat(semesterConversionArray[this.point.index] * 100, 1, ',', '.') + '%'
            },
            enabled: true
          },
          name: 'Taxa de conversão',
          color: '#7ABA1E',
          data: increaseBarByFactor(semesterConversionArray),
          tooltip: {
            headerFormat: '<span style="color: {series.color}">{point.key}</span><br>',
            pointFormatter: function() {
              let index = this.index;
              let name = this.series.name;
              let color = this.color;
              return '<span style="color: ' + color + '">' + name + ': ' +
                Highcharts.numberFormat(semesterConversionArray[index] * 100, 1, ',', '.') + '%</span>'
            },
            useHTML: true
          }
        }],
      }
    }
  }
}
</script>

<style>

</style>
